module.exports = __webpack_public_path__ + "img/logo.ef354586.png";